import { jsx as _jsx } from "react/jsx-runtime";
import { AppBar, Box } from '@mui/material';
import logo from '@assets/logo.svg';
export const Header = () => {
    return (_jsx(AppBar, { position: "fixed", elevation: 0, children: _jsx(Box, { sx: {
                display: 'flex',
                alignItems: 'center',
                height: '100%',
                px: 2,
                py: 1,
            }, children: _jsx(Box, { component: "img", src: logo, alt: "Fleet Edge Logo", sx: {
                    height: 'auto',
                    width: 'auto',
                    maxHeight: '100%',
                    objectFit: 'contain',
                } }) }) }));
};
